<template>
  <div class="comp-list-inquiry-firstname">
    <span>{{ computedFirstname }}</span>
    <template v-if="reviewFor">
      <span :title="`Zugeteilt von ${reviewFor}`"><Icon name="transfer" /></span>
    </template>
  </div>
</template>

<script>
  import { Store } from '@/store';
  import Icon from '@/components/ui/Icon';
  import InquiryStatus from '@/objects/InquiryStatus';

  export default {
    name: 'ListInquiriesFirstname',
    components: {
      Icon,
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {
      values: {
        type: Object,
        default: null,
      },
    },
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {};
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {
      computedFirstname() {
        return this.values?.firstname;
      },
      reviewFor() {
        const values = this.values || {};
        const user = Store.uuid;
        const psychologist = values.psychologist?.uuid;
        const reviewer = values?.reviewer?.uuid;
        const status = values?.status;
        if (user === reviewer && user !== psychologist && status === InquiryStatus.REVIEWING) {
          return this.values?.psychologist.name;
        }
        return null;
      },
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    // filters: {},
    //---------------------------------------------------
    //
    //  Validation Properties
    //
    //---------------------------------------------------
    // validations: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
      //----------------------------------
      // Event Handlers
      //----------------------------------
    },
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';

.comp-list-inquiry-firstname {
  span {
    position: relative;
    display: inline-block;
    margin-right: 8px;

    svg {
      position: relative;
      top: 3px;
      color: $color-signal-orange;
      width: 16px;
      height: 16px;
    }
    &:last-of-type {
      margin-right: 0;
    }
  }
}
</style>
